var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useTableDispatch } from "./context";
var Header = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    position: sticky;\n    top: 0;\n    grid-row-start: 1;\n    background-color: ".concat(theme.bgContent(), ";\n    border-bottom: 1px solid ").concat(theme.borderContent(), ";\n    width: 100%;\n    justify-content: space-between;\n    user-select: none;\n  ");
});
var MINIMUM_HEADER_WIDTH = 25;
var DRAG_WIDTH = 20;
var Span = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: calc(100% - ", "px);\n  overflow: hidden;\n"], ["\n  max-width: calc(100% - ", "px);\n  overflow: hidden;\n"])), DRAG_WIDTH);
var WidthDrag = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", "px;\n  height: 100%;\n  cursor: col-resize;\n"], ["\n  width: ", "px;\n  height: 100%;\n  cursor: col-resize;\n"])), DRAG_WIDTH);
export var TableHeader = function (_a) {
    var label = _a.label, index = _a.index;
    var _b = useState(false), canDrag = _b[0], setDrag = _b[1];
    var _c = useState(null), prevX = _c[0], setPrevX = _c[1];
    var header = useRef(null);
    var tableDispatch = useTableDispatch();
    var canUpdateWidth = useRef(true);
    var handleDrag = useCallback(function (e) {
        var _a, _b, _c;
        var timeout;
        if (canDrag) {
            console.log("DRAG");
            var parentElement = (_a = header === null || header === void 0 ? void 0 : header.current) === null || _a === void 0 ? void 0 : _a.parentElement;
            console.log({ e: e, header: header, parentElement: parentElement, scrollLeft: parentElement === null || parentElement === void 0 ? void 0 : parentElement.scrollLeft });
            if (prevX && prevX !== e.clientX && canUpdateWidth.current) {
                var nextWidth = ((_b = header.current) === null || _b === void 0 ? void 0 : _b.clientWidth) + (e.clientX - prevX);
                if (prevX > e.clientX) {
                    nextWidth = ((_c = header.current) === null || _c === void 0 ? void 0 : _c.clientWidth) - (prevX - e.clientX);
                }
                console.log({ header: header, prevX: prevX, clientX: e.clientX, nextWidth: nextWidth });
                nextWidth = Math.max(nextWidth, MINIMUM_HEADER_WIDTH);
                tableDispatch({
                    type: "SET_HEADER_WIDTH",
                    payload: { index: index, width: nextWidth },
                });
                canUpdateWidth.current = false;
                timeout = setTimeout(function () {
                    canUpdateWidth.current = true;
                }, 30);
                setPrevX(e.clientX);
            }
            if (prevX === null) {
                setPrevX(e.clientX);
            }
        }
        return function () {
            clearTimeout(timeout);
        };
    }, [canDrag, prevX, header, tableDispatch, index]);
    var stopDrag = useCallback(function () {
        setDrag(false);
        setPrevX(null);
        window.removeEventListener("mousemove", handleDrag);
    }, [handleDrag]);
    var startDrag = useCallback(function (e) {
        console.log({ e: e });
        setDrag(true);
        window.addEventListener("mousemove", handleDrag);
        window.addEventListener("mouseup", stopDrag);
    }, [handleDrag, stopDrag]);
    useEffect(function () {
        window.removeEventListener("mousemove", handleDrag);
        window.addEventListener("mousemove", handleDrag);
        window.removeEventListener("mouseup", stopDrag);
        window.addEventListener("mouseup", stopDrag);
        return function () {
            window.removeEventListener("mousemove", handleDrag);
            window.removeEventListener("mouseup", stopDrag);
        };
    }, [handleDrag, stopDrag]);
    return (React.createElement(Header, { ref: header },
        React.createElement(Span, null, label),
        React.createElement(WidthDrag, { onMouseDown: startDrag, onMouseUp: stopDrag })));
};
var templateObject_1, templateObject_2, templateObject_3;
